// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"277bf214","160":"00b5e912","208":"6e44e546","293":"28915426","453":"35dfc46e","516":"cb549db6","519":"47134b67","917":"36ff8a19","946":"8884115f"}[chunkId] + ".chunk.js";
};